var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('NuxtImg',{attrs:{"src":_vm.getImage(),"alt":_vm.getAltText(),"width":"1920","height":"1280","sizes":"xl:100vw lg:100vw md:100vw sm:100vw xs:100vw","format":"webp","loading":"lazy"}})}
var staticRenderFns = []

export { render, staticRenderFns }